import { Box, FormControlLabel, Button, styled } from '@mui/material';

// Styled components
export const FilterBar = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 0),
  backgroundColor: theme.palette.secondary.light,
  color: theme.palette.primary.main,
  maxHeight: '4rem',
}));

export const FilterOption = styled(FormControlLabel)(({ theme }) => ({
  marginRight: theme.spacing(2),
  '& .MuiTypography-root': {
    color: '#5a6474',
    fontWeight: 500,
  },
}));

export const SortButton = styled(Button)(() => ({
  color: '#5a6474',
  textTransform: 'none',
  fontSize: '14px',
  fontWeight: 500,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexGrow: 1,
  minWidth: 0,
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  textAlign: 'left',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
}));
